const equipment = new URL('../../icons/equipment.png', import.meta.url).href

export default {
  type: 'Equipment',
  description: 'Equipment',
  icon: equipment,
  group: 'EQP',
  model: {
    type: 'Equipment',
    left: 100,
    top: 100,
    width: 40,
    height: 30
  }
}
